import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";

/*
 * View of dialogue model responsible for workitem type
 * */
class WorkItemTypeDialog {

    // #region Constructor

    /**
     * Constructor
     * @param parent The parent view model
     */
    constructor(parent) {
        this.Parent = parent;
    }
    // #endregion

    // #region Properties

    /** Bao  */
    Bao = Bao;
    /** Default dialog */
    Dialog: BaoDialog;
    /** The parent view model */
    Parent: any;

    /** Result from dialog */
    DialogResult = ko.observable();
    /** True if the dialog is displayed */
    DialogShown: boolean = false;

    SelectedItem = ko.observable();
    Items = ko.observableArray();
    Deferred = $.Deferred();
    TabPage: any;
    // #endregion


    // #region Methods
    /***
     * Event will be fired when user select the workitem from the dialog
     * */
    SelectItem = (item) => {
        this.Deferred.resolve(item);
        if (this.Dialog != null && this.Dialog.Close != null) {
            this.SelectedItem(item);
            this.DialogResult(true);
            this.Dialog.Close();
        }
    }
    /***
     * Open the new dialog to select the workitem type
     * */
    OpenDialog = () => {
        this.Parent.TabPage.IsLoading(true);
        Bao.post("WorkItem/GetWorkItemTypeDialog", JSON.stringify({ workItemCollectionId: this.Parent.WorkItemCollectionId()}), (result) => {
            //If we have more than one workitem type then user needs to select one of them from the dialog
            if (result?.WorkItemTypes != null && result?.WorkItemTypes?.length > 1) {
                this.Dialog = new BaoDialog(Bao.Session.ApplicationName);
                this.Items(result.WorkItemTypes);
                this.Dialog.ViewModel(this);
                this.Dialog.Width(600);
                this.Dialog.Buttons([
                    {
                        Title: Bao.Session.GetMessage("msgOk"),
                        Click: () => {
                            this.Deferred.resolve(this.SelectedItem());
                            this.DialogResult(true);
                            this.Dialog.Close();
                        },
                        Enabled: ko.observable(true)
                    },
                    {
                        Title: Bao.Session.GetMessage("msgCancel"),
                        Click: () => {
                            this.Deferred.resolve();
                            this.DialogResult(false);
                            this.Dialog.Close();
                        },
                        Enabled: ko.observable(true)
                    }
                ]);
                this.Dialog.Closed = () => {
                    this.Deferred.resolve();
                };
                this.Dialog.Template(result?.Template);
                this.Dialog.Open();
                this.Parent.TabPage.IsLoading(false);
            }
            //If we have only one record then no popup will be displayed 
            else if (result?.WorkItemTypes != null && result?.WorkItemTypes?.length == 1) {
                this.Parent.TabPage.IsLoading(false);
                this.SelectedItem(result?.WorkItemTypes[0]);
                this.DialogResult(true);
                this.Deferred.resolve(this.SelectedItem());
            }
            else {
                new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgWorkItemCollectionHasNoAssignedWorkItemType"), "info");
                this.Parent.TabPage.IsLoading(false);
                this.DialogResult(false);
                this.Deferred.resolve();
            }
        });
        return this.Deferred.promise();
    };

    // #endregion
}
export default WorkItemTypeDialog;